import React, { useState } from "react";
import axios from "axios";
import "./FormInput.css";
import FormInput from "./FormInput";

const Register = () => {
  const [values, setValues] = useState({
    username: "",
    email: "",
    birthday: "",
    password: "",
    confirmPassword: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const inputs = [
    {
      id: 1,
      name: "username",
      type: "text",
      placeholder: "User Name",
      errorMessage:
        "Username should be 3-16 characters and should not include any special characters!",
      label: "User Name",
      pattern: "^[A-Za-z0-9]{3,16}$",
      required: true
    },
    {
      id: 2,
      name: "email",
      type: "email",
      placeholder: "Email",
      errorMessage: "It should be a valid email address!",
      label: "Email",
      unique: true,
      required: true
    },
    {
      id: 3,
      name: "birthday",
      type: "date",
      placeholder: "Birthday",
      errorMessage:
        "Your age must between 01/01/1970-2016 years old to register.",
      pattern: "d{1,2}/d{1,2}/d{4}",
      label: "Birthday",
      min: "1970-01-01",
      max: "2016-01-01",
      required: true
    },
    {
      id: 4,
      name: "password",
      type: "password",
      placeholder: " Current Password",
      errorMessage:
        "Password should be 8-20 characters and include at least 1 Capital letter, 1 number and 1 special character for example: Abcd123@",
      label: "Password",
      pattern:
        "^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$",
      required: true
    },
    {
      id: 5,
      type: "password",
      name: "confirmPassword",
      placeholder: "confirm Password",
      errorMessage: "Password does not match!",
      label: "confirm Password",
      pattern: values.password,
      required: true
    }
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = "./login";
    setIsSubmitting(true);
    const { username, email, birthday, password, confirmPassword } = values;

    axios
      .post("http://localhost:5000/register", {
        username,
        email,
        birthday,
        password,
        confirmPassword
      })
      .then((response) => {
        const data = response.data;
        console.log(data, "userRegister");
        if (data.status === "ok") {
          alert("Registration successful");
        } else {
          alert("Something went wrong");
        }
      })
      .catch((error) => {
        console.error("Registration failed", error);
        alert("An error occurred during registration");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  console.log(values);

  return (
    <div className="login-container">
      <form className="login-form " onSubmit={handleSubmit}>
        <h1 className="headings">Register</h1>
        {inputs.map((input) => (
          <FormInput
            className="login-form form-input "
            key={input.id}
            {...input}
            value={values[input.name]}
            onChange={onChange}
          />
        ))}

        <button className="login-form " type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
        <p>
          Already registered? <a href="Login">SignIn</a>
        </p>
      </form>
    </div>
  );
};

export default Register;
